import axios from './axios';

const ServiceProviderService = {
  getProviders: (page = 1, search = '') => axios.get(`/api/v1/service-providers?page=${page}&search=${encodeURIComponent(search)}`),
  getProvider: (id) => axios.get(`/api/v1/service-providers/${id}`),
  createProvider: (data) => axios.post('/api/v1/service-providers', data),
  updateProvider: (id, data) => axios.put(`/api/v1/service-providers/${id}`, data),
  deleteProvider: (id) => axios.delete(`/api/v1/service-providers/${id}`),
};

export default ServiceProviderService;
